module.exports = __webpack_public_path__ + "static/media/1l3s.6f1d2a44.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/kit/icons/kit/1l3s.png
// module id = 814
// module chunks = 0